<template>
  <div class="row justify-between no-wrap">
    <q-chip
      v-if="props.value && props.value.id > 0"
      class="col-auto"
      :class="{ 'model-chip': !props.col.editDisabled }"
      :label="modelLabel"
      :title="modelLabel"
      :clickable="!props.col.editDisabled"
      @click.stop="$emit('edit-model', { value: props.value, newTab: props.col.newTab, subpath: props.col.editPath || $_.kebabCase(props.value.collectionVariableName) })"
    />
    <template v-if="showSubmodelFilter">
      <!-- Clear filter button -->
      <q-btn
        v-if="appliedSubmodelFilter"
        class="col-auto text-grey-9"
        icon="close"
        size="sm"
        @click.stop="$emit('apply-submodel-filter', { col: props.col, value: null })"
      />
      <!-- Apply filter button -->
      <q-btn
        v-else
        class="col-auto text-grey-9"
        icon="filter_alt"
        size="sm"
        @click.stop="$emit('apply-submodel-filter', { col: props.col, value: props.value })"
      />
    </template>
  </div>
</template>

<script>
import TableCellMixin from 'src/modules/admin/components/model-table/components/TableCellMixin'

export default {
  name: 'ModelChipCell',
  mixins: [TableCellMixin],
  props: {
    variables: {
      type: Object,
      required: false,
      default: () => ({})
    }
  },
  emits: ['edit-model', 'apply-submodel-filter'],
  computed: {
    modelLabel () {
      return this.props.value?.description || this.props.value?.name || `${this.props.value?.typeName} ${this.props.value?.id}`
    },
    showSubmodelFilter () {
      if (_.isNil(this.props.value?.id)) return false
      if (this.props.value?.id <= 0) return false // Hide if model is not remote (use id in case model not inflated)
      if (this.props.col.filterDisabled) return false // Hide if filter is disabled

      return true
    },
    appliedSubmodelFilter () {
      if (this.variables[this.props.col.name + 'Id'] === this.props.value?.id) return true

      return false
    }
  }
}
</script>

<style lang="scss" scoped>
.model-chip:hover {
  outline: 2px solid #333;
}
</style>
